<div class="container" (click)="handleClick($event)"
    [ngClass]="{ 'container-checked': value, 'disabled-style': disabled }" [ngStyle]="style">
    <img id='checkbox-check' class="icon-checked" *ngIf="value" [ngStyle]="iconStyle" />
</div>